import React from 'react';
import { CommissioningInfo } from '../CommissioningInfo';
import { DMActionsInfo } from '../DMActionsInfo';
import styles from './ActionsInfoPanel.module.css';

const ActionsInfoPanel = ({ lastCommissionDate, latestActiveAction }) => {
  return (
    <div className={styles.root}>
      <CommissioningInfo lastCommissionDate={lastCommissionDate} />
      <DMActionsInfo latestActiveAction={latestActiveAction} />
    </div>
  );
};

export default ActionsInfoPanel;
